/* JobViewRenderer.js */

"use strict";

const ActivityTypeColumn = require("../../column_renderers/activity_type/ActivityTypeComponent");
const SnapshotColumn = require("../../column_renderers/snapshot/SnapshotComponent");
const DescriptionColumn = require("../../column_renderers/description/DescriptionComponent");
const StatusColumn = require("../../column_renderers/status/StatusComponent");
const ActionsColumn = require("../../column_renderers/actions/ActionsComponent");
const Grid = require("@gluenetworks/steve_ui_widgets").GridGl.Grid;
const Registrations = require("../../../../../../../RegistrationNamespaces");

class JobViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("job-view-gl");
        this._rootElem.component = this._model;

        let columnConfig = {
            activityType: {
                label: "Activity Type",
                columnRendererComponent: ActivityTypeColumn,
                width: 0.03
            },
            snapshot: {
                label: "Snapshot",
                columnRendererComponent: SnapshotColumn,
                width: 0.1
            },
            description: {
                label: "Description",
                columnRendererComponent: DescriptionColumn,
                width: 0.37
            },
            status: {
                label: "Status",
                columnRendererComponent: StatusColumn,
                centralColumn: true
            },
            actions: {
                label: "Actions",
                columnRendererComponent: ActionsColumn,
                sortable: false,
                width: 0.5
            }
        };

        this._jobListGrid = new Grid({
            columns: columnConfig,
            showHeader: false,
            columnOrder: ["activityType", "snapshot", "description", "status", "actions"]
        });
        this._gridRows = {};

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr).then(
            () => {
                //TODO set all class members to undefined here
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._jobListGrid.shutdown().then(() => {
                    this._jobListGrid = undefined;
                });
            },
            (err) => {
                this._logger.warn({ error: err }, "JobViewRenderer.shutdown() error.");
            }
        );
    }
    _registerListeners() {
        this._jobListGrid.on("UserSorted", (this._onGridUserSorted = this._onGridUserSorted.bind(this)));
        this._jobListGrid.on("UserSelectedRows", (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this)));
        this._jobListGrid.on("UserRowDoubleClicked", (this._onGridUserRowDoubleClicked = this._onGridUserRowDoubleClicked.bind(this)));
        this._jobListGrid.on("GridAction", (this._onGridAction = this._onGridAction.bind(this)));
    }
    _unregisterListeners() {
        this._jobListGrid.removeAllListeners("UserSorted");
        this._jobListGrid.removeAllListeners("UserSelectedRows");
        this._jobListGrid.removeAllListeners("UserRowDoubleClicked");
        this._jobListGrid.removeAllListeners("GridAction");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._jobListGrid.renderer.rootElement);
            }
            this._renderGridRows();
            //this._model.gameEditor.setFilterProperties({whatevs: true});

            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderGridRows() {
        this._gridRows = {};
        let data = this._model.getJobList();

        //Marshall data
        data.forEach((obj) => {
            this._gridRows[obj.id] = {
                activityType: obj.activityType,
                snapshot: obj.snapshot,
                description: obj.description,
                status: obj.status,
                actions: obj.actions
            };
        });
        this._jobListGrid.setRows(this._gridRows);
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onGridUserSorted(columnId, sort) {
        console.info("GRID SORTED: ", columnId);
        console.info("SORT: ", sort);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        console.info("ROWS SELECTED: ", selectedRowIds);
    }

    _onGridUserRowDoubleClicked(selectedRowId) {
        // TODO: open up the viewMore view
        console.info("ROW DOUBLE CLICKED: ", selectedRowId);
    }

    _onGridAction(actionData) {
        let action = actionData.eventData.action;
        // let rowId = actionData.rowId;
        switch (action) {
            case "viewMore":
                // TODO: need to pass data
                this.model.gameEditor.setActiveView(Registrations.DIE_VIEW_LOGS, [
                    {
                        value: {
                            fqn: Registrations.DIE_VIEW_JOB
                        },
                        content: "Job Blah Blah",
                        left: {
                            arrow: {
                                direction: "left"
                            }
                        }
                    }
                ]);
                break;
        }
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = JobViewRenderer;
